import React, { useRef, useEffect } from "react";

function MiniGoogleMap({ lat, lng, markerName }) {
  const mapRef = useRef(null);

  useEffect(() => {
    if (window.google && mapRef.current) {
      const map = new window.google.maps.Map(mapRef.current, {
        center: { lat, lng },
        zoom: 12,
      });

      const diverDownFlagIcon = {
        url: '/diver-down-flag.svg', // Assuming your SVG file is named "diver-down-flag.svg" in the public directory
        scaledSize: new window.google.maps.Size(32, 48), // Adjust size as needed
        origin: new window.google.maps.Point(0, 0),
        anchor: new window.google.maps.Point(16, 48),
      };
      
      const marker = new window.google.maps.Marker({
        position: { lat, lng },
        map: map,
        title: markerName || "Marker",
        icon: diverDownFlagIcon,
      });

      marker.addListener("click", () => {
        const infoWindow = new window.google.maps.InfoWindow({
          content: `<div style="text-align: center;">
                      <strong>${markerName || "Marker"}</strong><br>
                      <a href="https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}" target="_blank" rel="noopener noreferrer">
                        Get Directions
                      </a>
                    </div>`,
        });
        infoWindow.open(map, marker);
      });
    } else {
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBRQwYPeru_FEcLCkVBweQQRjPLBXkzJDs`; // Replace with your API key
      script.async = true;
      script.onload = () => {
        if (mapRef.current) {
          const map = new window.google.maps.Map(mapRef.current, {
            center: { lat, lng },
            zoom: 12,
          });

          const marker = new window.google.maps.Marker({
            position: { lat, lng },
            map: map,
            title: markerName || "Marker",
          });

          marker.addListener("click", () => {
            const infoWindow = new window.google.maps.InfoWindow({
              content: `<div style="text-align: center;">
                          <strong>${markerName || "Marker"}</strong><br>
                          <a href="https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}" target="_blank" rel="noopener noreferrer">
                            Get Directions
                          </a>
                        </div>`,
            });
            infoWindow.open(map, marker);
          });
        }
      };
      document.head.appendChild(script);
    }
  }, [lat, lng, markerName]);

  return <div ref={mapRef} style={{ width: "100%", height: "400px" }} />;
}

export default MiniGoogleMap;
